import { render, staticRenderFns } from "./thawOrfreezeModal.vue?vue&type=template&id=72eda716&scoped=true"
import script from "./thawOrfreezeModal.vue?vue&type=script&lang=js"
export * from "./thawOrfreezeModal.vue?vue&type=script&lang=js"
import style0 from "./thawOrfreezeModal.vue?vue&type=style&index=0&id=72eda716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eda716",
  null
  
)

export default component.exports